import { render, staticRenderFns } from "./PDPComment.vue?vue&type=template&id=0a8bedea&scoped=true&"
import script from "./PDPComment.vue?vue&type=script&lang=js&"
export * from "./PDPComment.vue?vue&type=script&lang=js&"
import style0 from "./PDPComment.vue?vue&type=style&index=0&id=0a8bedea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8bedea",
  null
  
)

export default component.exports